<template lang="pug">
	.audio-tracker-recorder
		template(v-if="showUI")
			.button.flex-row.center.align-center(:title="$tCaption('Recorder')", @click="v => !disabled && showPopup(true)", :disabled="disabled")
				i.fas.fa-circle
		Popup(v-if="innerPopupVisible", :popupVisible="innerPopupVisible", classes="tracker-dark", :width="recorderOpts.speakingText ? 680 : 480", :height="recorderOpts.speakingText ? 640 : 440", :closeOnOutsideClick="false", @hiding="onHiding")
			AudioTrackerRecorder(v-bind="$props", :opts="recorderOpts" ref="recorder", @result-wav="base64 => hasResult = !!base64", @is-recording="v => hasResult = hasResult || v")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Save', '@actions')", type="success", @click="save", :disabled="!hasResult")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="cancel")
</template>

<script>
	import Popup from 'app-core/Popup.vue';
	import AudioTrackerRecorder from './AudioTrackerRecorder.vue';
	import DxButton from 'devextreme-vue/button';
	import VueTypes from 'vue-types';

	export default {
		translationCategory: 'audioTracker.AudioTrackerRecorder',
		name: 'audio-tracker-recorder',
		components: {Popup, DxButton, AudioTrackerRecorder},
		props: {
			track: VueTypes.any.def(null),
			tracker: VueTypes.any.def(null),
			audioContext: VueTypes.any.def(null),
			showUI: VueTypes.bool.def(true),
			popupVisible: VueTypes.bool.def(false),
			disabled: VueTypes.bool.def(false)
		},
		data() {
			return {
				innerPopupVisible: false,
				recorderOpts: {},
				hasResult: false
			};
		},		
		watch: {
			popupVisible(v) {
				this.showPopup(v);
			}
		},
		mounted() {
			if (__DEBUG__)
				window.recorderPopup = this;
			this.showPopup(this.popupVisible);
		},
		destroyed() {
			delete this.$onCloseHandler;
		},
		methods: {
			onHiding(v) {
				if (!v)
					this.stopRecording(); 
				this.$emit('popup', v);
				this.innerPopupVisible = false;
				if (!v && this.$onCloseHandler) {
					this.$onCloseHandler();
				}
			},
			stopRecording() {
				return this.$refs.recorder && this.$refs.recorder.stopRecording() || Promise.resolve(null);
			},
			cancel() {
				this.stopRecording();
				this.showPopup(false);
			},
			showPopup(v, opts) {
				this.innerPopupVisible = false;
				this.hasResult = false;
				if (v) {
					this.$onCloseHandler = opts?.onClose;
					this.recorderOpts = opts || {};
					setImmediate(() => {
						if (this._isDestroyed) return;
						this.innerPopupVisible = true;
					})
				}
				this.$emit('popup', v);
			},
			save() {
				const instance = this.$refs.recorder;
				this.stopRecording().then(() => {
					this.$emit('save', instance.recorder.resultWav, instance.title, instance.recorder.trackerInitPosition, instance.fileUploading);
					this.showPopup(false);
				});
			},
		}
	};
</script>
<style lang='scss'>
	.audio-tracker-recorder {
		@import "main/themes/generated/variables.base.scss";

		.recorder-time {
			font-size: 50px;
			font-weight: 100;
			transition: 0.3s;

			&.countdown.red {
				color: #f34d4d;
			}
		}

		.text-area {
			min-height: 180px;
		}
	}
</style>
